module.exports = __webpack_public_path__ + "img/bory3_small.8d590e15.png";